import { useEffect } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { CounterpartyIdField } from '@/pages/instruments/new-instrument/form-fields/CounterpartyIdField'
import { CurrencyIdField } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdField'
import { FundIdField } from '@/pages/instruments/new-instrument/form-fields/FundIdField'
import { ISINField } from '@/pages/instruments/new-instrument/form-fields/ISINField'
import { InitialObservationDateField } from '@/pages/instruments/new-instrument/form-fields/InitialObservationDateField'
import { MaturityDateField } from '@/pages/instruments/new-instrument/form-fields/MaturityDateField'
import { NotionalField } from '@/pages/instruments/new-instrument/form-fields/NotionalField'
import { ProductResultFormField } from '@/pages/instruments/new-instrument/form-fields/ProductResultFormField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { SedolField } from '@/pages/instruments/new-instrument/form-fields/SedolField'
import { SettlementCycleField } from '@/pages/instruments/new-instrument/form-fields/SettlementCycleField'
import { StructureNameField } from '@/pages/instruments/new-instrument/form-fields/StructureNameField'
import { UnderlyingsFormField } from '@/pages/instruments/new-instrument/form-fields/UnderlyingsFormField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { AutocallStandardSchemaType } from '@/pages/instruments/new-instrument/schemas/autocall-standard.schema'

export interface BaseStructuredFormFieldsProps extends React.PropsWithChildren {}

export const BaseStructuredFormFields: React.FC<BaseStructuredFormFieldsProps> = ({ children }) => {
  const { trigger, control } = useFormContext<AutocallStandardSchemaType>()

  const [
    product_result,
    underlyings,
    structure_name,
    isin,
    currency_id,
    counterparty_id,
    sedol,
    notional,
    fund_id,
  ] = useWatch({
    control,
    name: [
      'product_result',
      'underlyings',
      'structure_name',
      'isin',
      'currency_id',
      'counterparty_id',
      'sedol',
      'notional',
      'fund_id',
    ],
  })

  useEffect(() => {
    trigger()
  }, [
    product_result,
    underlyings,
    structure_name,
    isin,
    currency_id,
    counterparty_id,
    sedol,
    notional,
    fund_id,
  ])

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-6'}>
      <ProductResultFormField />
      <UnderlyingsFormField />
      <FormFieldRow>
        <StructureNameField />
        <ISINField />
        <CurrencyIdField />
        <CounterpartyIdField />
      </FormFieldRow>
      <FormFieldRow>
        <SedolField />
        <NotionalField />
        <FundIdField />
        <SettlementCycleField />
      </FormFieldRow>
      <FormFieldRow>
        <InitialObservationDateField />
        <MaturityDateField />
        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>
      {children}
    </div>
  )
}
